type HasUpdatedAt = { updatedAt: Date | string };

export const getLatestUpdatedEntry = <TReturn = any>(list: HasUpdatedAt[]): TReturn => {
    const [latest] = list.sort((modelA, modelB) =>
        (new Date(modelA.updatedAt) < new Date(modelB.updatedAt)) ? 1 : -1
    );
    return latest as any;
}
